export default {
  label: {
    jobDetail: 'Job Detail Page',
    mobile: 'Mobile Web',
    pc: 'PC Web',
    weChatShareTipMessage: 'You can set up the content of WeChat sharing here. The sharing icon should not be smaller than 300px x 300px; and you can use the placeholders: #JOB_TITLE#， #JOB_LOCATION# and #COMPANY_NAME# to replace the properties of job or company automatically inner the sharing content.',
    pageSettingTitleKey: 'Job Description Customization',
    jobDescriptionTipKey: 'Your Job Description',
    fieldManagement: 'Field Management'
  }
}
